import { IconButton } from '@salecycle/ui-component-library';
import { PropsWithChildren } from 'react';
import styled from 'styled-components';

export interface DrawerCloseProps {
  onClose: () => void;
}

const DrawerCloseWrapper = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
  padding: 1rem;
`;

export function DrawerClose({ onClose }: PropsWithChildren<DrawerCloseProps>) {
  return (
    <DrawerCloseWrapper>
      <IconButton ariaLabel="Close drawer" icon="times" onClick={onClose} />
    </DrawerCloseWrapper>
  );
}
